<template>
  <div class="loginForm" v-show="isShow" @keydown.enter="handleSubmit">
    <div class="title">欢迎登录</div>
    <div class="title1">WELCOME TO LOGIN</div>
    <el-form
      class="user-layout-login"
      ref="formLogin"
      :model="form"
      :rules="rules"
    >
      <el-form-item prop="account">
        <el-input
          type="text"
          autocomplete="off"
          maxLength="11"
          placeholder="请输入手机号"
          v-model.trim="form.account"
          @keyup.enter.native="handleSubmit"
        >
          <svg
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            slot="prefix"
          >
            <use xlink:href="#icon-shouji1"></use>
          </svg>
        </el-input>
      </el-form-item>
      <el-form-item prop="password" style="margin-bottom: 12px">
        <el-input
          autocomplete="off"
          :type="isShowPassword ? 'text' : 'password'"
          maxLength="12"
          placeholder="请输入密码"
          v-model.trim="form.password"
          @keyup.enter.native="handleSubmit"
        >
          <svg
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            slot="prefix"
          >
            <use xlink:href="#icon-mima"></use>
          </svg>
          <svg
            class="show-password"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            slot="suffix"
            @click="isShowPassword = !isShowPassword"
          >
            <use
              :xlink:href="isShowPassword ? '#icon-browse' : '#icon-eye-close'"
            ></use>
          </svg>
        </el-input>
      </el-form-item>
      <el-form-item style="margin-bottom: 15px; text-align: left">
        <el-checkbox v-model.trim="form.remember"> 记住密码 </el-checkbox>
      </el-form-item>
      <el-form-item style="margin-bottom: 20px">
        <el-button
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="state.loginBtn"
          :disabled="state.loginBtn"
          @click="handleSubmit"
          >登录</el-button
        >
      </el-form-item>
      <div class="text-button">
        <span @click="onRegister">立即注册</span>
        <span @click="onSetPassword">忘记密码?</span>
      </div>
      <div class="third">
        <span></span>
        <p>第三方账号登录</p>
        <span></span>
      </div>
      <img
       class="wechat"
       @click="wechatQrCode"
       src="@/assets/images/wechat.svg"
     />

    </el-form>
  </div>
</template>

<script>
import {
  inviteMemberApi,
  detectTeam,
  switchTeam,
  teamListSelect
} from '@/api/teamManagement'
import { mapActions } from 'vuex'
import md5 from 'md5'
import { validatePhoneAdmin, validatePassword } from '@/utils/rules'
// import { validatePhoneAdmin } from '@/utils/rules'
import { aesEncrypt, aesDecrypt } from '@/utils/ase'
export default {
  name: 'LoginForm',
  data () {
    return {
      isShow: true,

      capctchaCheck: false,
      loginBtn: false,
      isShowPassword: false,

      rules: {
        account: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhoneAdmin, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      grant_type: 'shine_login',
      form: {
        account: '',
        password: '',
        remember: false
      },
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        grant_type: 'shine_login'
      }
    }
  },
  mounted () {
    const account = localStorage.getItem('account')
    const password = aesDecrypt(localStorage.getItem('password'))
    if (account && password) {
      this.form.account = account
      this.form.password = password
      this.form.remember = true
    } else {
      this.form.account = ''
      this.form.password = ''
      this.form.remember = false
    }
  },
  created () {},
  methods: {
    ...mapActions(['Login', 'Logout', 'GetInfo']),
    show (isShow) {
      this.clear()
      this.isShow = isShow
    },
    handleSubmit (e) {
      e.preventDefault()
      this.loginForm()
    },
    loginForm () {
      this.$refs.formLogin.validate((succ) => {
        if (succ) {
          this.state.loginBtn = true
          const loginParams = {}
          loginParams.username = this.form.account
          loginParams.grant_type = this.grant_type
          loginParams.password = md5(this.form.password)
          this.Login(loginParams)
            .then((res) => this.loginSuccess(res))
            .finally(() => {
              this.state.loginBtn = false
              this.capctchaCheck = false
            })
        } else {
          setTimeout(() => {
            this.state.loginBtn = false
          }, 600)
        }
      })
    },
    async loginSuccess (res) {
      if (res.code === 200) {
        if (this.form.remember) {
          // 记住密码
          localStorage.setItem('account', this.form.account)
          localStorage.setItem('password', aesEncrypt(this.form.password))
        } else {
          localStorage.removeItem('account')
          localStorage.removeItem('password')
        }

        // 登录成功后跳转到地图管理页
        let { teamId, noncestr } = this.$route.query
        teamId = Number(teamId)
        if (noncestr) {
          // 通过邀请链接登录
          const { data } = await this.GetInfo()
          const userId = data.id
          const res = await detectTeam({ teamId, userId })
          if (res.data) {
            this.$message.success('你已加入该团队!')
            // localStorage.setItem('teamId', teamId)
            // await switchTeam({ teamId })
            // await this.GetInfo()
            this.$router.push({ path: '/controlPlatform' })
          } else {
            await inviteMemberApi({ noncestr })
            this.$message.success('加入团队成功!')
            // localStorage.setItem('teamId', teamId)
            // await switchTeam({ teamId })
            // await this.GetInfo()
            this.$router.push({ path: '/controlPlatform' })
          }
        } else {
          // 直接登录
          const { data } = await teamListSelect()
          await switchTeam({ teamId: data[0].id })
          this.$router.push({
            path: '/controlPlatform'
          })
        }
      }
    },
    clear () {
      this.form = this.$options.data().form
      if (this.$refs.formLogin) {
        this.$refs.formLogin.clearValidate()
      }
      this.isShowPassword = false
    },
    close () {
      this.clear()
    },
    // 跳转注册
    onRegister () {
      // this.$router.push({
      //   name: 'register'
      // })
      this.$emit('showRegisterMsg')
    },
    // 跳转重设密码
    onSetPassword () {
      // this.$router.push({
      //   name: 'resetPassword'
      // })
      this.$emit('showSetPasswordMsg')
    },
    // 跳转到微信登录
    wechatQrCode () {
      this.$emit('showWechatQrCodeMsg')
    }
  }
}
</script>

<style lang="scss">
.loginForm {
  width: 424px;
  height: 542px;
  background: url("~@/assets/images/bg2.png") no-repeat;
  background-size: contain;
  backdrop-filter: blur(5px);
  // border: 1px solid #565759;
  // box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.8);
  // border-radius: 12px;
  .title {
    font-size: 36px;
    font-family: Source Han Sans SC;
    color: #ffffff;
    text-shadow: 0px 3px 9px rgba(93, 204, 255, 1),
      0px 2px 34px rgba(77, 199, 255, 1);
    text-align: center;
    margin-top: 42px;
    letter-spacing: 12px;
  }
  .title1 {
    margin-bottom: 45px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #ffffff;
    text-align: center;
  }
  .user-layout-login {
    padding: 0 50px;
    input::placeholder {
      color: #fff !important;
      opacity: 0.7 !important;
    }
    .el-checkbox .el-checkbox__input .el-checkbox__inner {
      border: 1px solid transparent;
    }
    .el-input__suffix {
      right: 10px;
      top: 2px;
    }
    .is-error .el-input__inner {
      border-color: #f54949;
    }
    .el-input__prefix {
      top: 3px;
      left: 10px;
    }
    .login-button {
      width: 100%;
      height: 42px;
      font-size: 18px !important;
      border-radius: 6px;
    }
    .show-password {
      color: #999;
      cursor: pointer;
      &:hover {
        color: $hover-color;
      }
    }
    svg {
      color: #aaa;
      font-size: 16px;
    }
    .text-button {
      display: flex;
      justify-content: space-between;
      span {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
        &:hover {
          color: #00a4f0;
        }
      }
    }
    .third {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 10px 0;
      span {
        width: 110px;
        height: 1px;
        background: #eeeeee;
        opacity: 0.1;
        transform: translateY(-4px);
      }
      p {
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #999999;
      }
    }
    .wechat{
      width: 36px;
      cursor: pointer;
    }
  }
}
</style>
